type AllowedHeaderTypes = 'course-report' | 'enrolled-users' | 'user-report' | 'enrolled-courses' | 'lessons' | 'topics' | 'assignments' | 'quiz-details' | 'team-members' | 'team-licenses' | 'team-members-seat'

type TableHeaders = {
    id: string,
    displayName: string
}[]

const courseReportHeaders = (): TableHeaders =>{
    return [
        {
            id: 'courseId',
            displayName: 'ID'
        },
        {
            id: 'course',
            displayName: 'COURSE'
        },
        {
            id: 'enrolled',
            displayName: 'ENROLLED'
        },
        {
            id: 'inProgress',
            displayName: 'IN PROGRESS'
        },
        {
            id: 'completed',
            displayName: 'COMPLETED'
        },
        {
            id: 'notStarted',
            displayName: 'NOT STARTED'
        }
    ]
}

const enrolledUsersHeaders = (): TableHeaders =>{
    return [
        {
            id: 'userId',
            displayName: 'User ID'
        },
        {
            id: 'name',
            displayName: 'Name'
        },
        {
            id: 'email',
            displayName: 'Email'
        },
        {
            id: 'dateEnrolled',
            displayName: 'Date Enrolled'
        },
        {
            id: 'dateExpiration',
            displayName: 'Date Expiration'
        },
        {
            id: 'dateCompleted',
            displayName: 'Date Completed'
        },
        {
            id: 'completePercentage',
            displayName: 'Complete Percentage'
        },
    ]
}

const userReportHeaders = (): TableHeaders =>{
    return [
        {
            id: 'userId',
            displayName: 'User ID'
        },
        {
            id: 'name',
            displayName: 'Name'
        },
        {
            id: 'email',
            displayName: 'Email'
        },
        {
            id: 'latestActivity',
            displayName: 'Latest Activity'
        },
        {
            id: 'enrolledCount',
            displayName: 'Enrolled Courses'
        },
        {
            id: 'notStartedCount',
            displayName: 'Not Started Courses'
        },
        {
            id: 'inProgressCount',
            displayName: 'In Progress Courses'
        },
        {
            id: 'completedCount',
            displayName: 'Completed Courses'
        },
    ]
}

const enrolledCoursesHeaders = (): TableHeaders => {
    return [
        {
            id: 'courseId',
            displayName: 'Course ID'
        },
        {
            id: 'course',
            displayName: 'Course Name'
        },
        {
            id: 'completePercentage',
            displayName: 'Complete Percentage'
        },
        {
            id: 'dateCompleted',
            displayName: 'Date Completed'
        },
        {
            id: 'avgQuizScore',
            displayName: 'Avg Quiz Score'
        },
    ]
}

const courseLessonDetailHeaders = (): TableHeaders => {
    return [
        {
            id: 'lessonName',
            displayName: 'Lesson Name'
        },
        {
            id: 'lessonOrder',
            displayName: 'Lesson Order'
        },
        {
            id: 'lessonStatus',
            displayName: 'Lesson Status'
        },
    ]
}

const courseTopicDetailHeaders = (): TableHeaders => {
    return [
        {
            id: 'topicOrder',
            displayName: 'Topic Order'
        },
        {
            id: 'topicName',
            displayName: 'Topic Name'
        },
        {
            id: 'topicStatus',
            displayName: 'Topic Status'
        },
        {
            id: 'topicAssociatedLesson',
            displayName: 'Associated Lesson'
        },
    ]
}

const courseAssignmentDetailHeaders = (): TableHeaders => {
    return [
        {
            id: 'assignmentName',
            displayName: 'Assignment Name'
        },
        {
            id: 'assignmentApproval',
            displayName: 'Approval Status'
        },
        {
            id: 'assignmentPoints',
            displayName: 'Points'
        },
        {
            id: 'assignmentSubmittedDate',
            displayName: 'Submitted On'
        },
    ]
}

const userQuizDetails = (): TableHeaders => {
    return [
        {
            id: 'quizId',
            displayName: 'Quiz Name'
        },
        {
            id: 'quizQuestion',
            displayName: 'Quiz Question'
        },
    ]
}


const userTeamMembers = (): TableHeaders => {
  return[
    {
      id: 'userId',
      displayName: 'User ID'
    },
    {
      id: 'firstName',
      displayName: 'First Name'
    },
    {
      id: 'lastName',
      displayName: 'Last Name'
    },
    {
      id: 'fullName',
      displayName: 'Full Name'
    },
    {
      id: 'username',
      displayName: 'Username'
    },
    {
      id: 'role',
      displayName: 'Role'
    },
    {
      id: 'email',
      displayName: 'Email'
    },
    {
      id: 'avatarUrl',
      displayName: 'Avatar Url'
    },
  ]
}

const userTeamLicenses = (): TableHeaders => {
    return[
      {
        id: 'licenseTypeID',
        displayName: 'License Type ID'
      },
      {
        id: 'name',
        displayName: 'Name'
      },
      {
        id: 'product',
        displayName: 'Product'
      },
      {
        id: 'total',
        displayName: 'Total'
      }
    ]
  }

  const userTeamMemberSeat = (): TableHeaders => {
    return[
      {
        id: 'latestActivity',
        displayName: 'Latest Activity'
      },
      {
        id: 'displayName',
        displayName: 'Member'
      },
      {
        id: 'role',
        displayName: 'Role'
      },
    ]
  }


export const getExportHeaders = ( type: AllowedHeaderTypes ): TableHeaders => {

    switch( type ){
        case 'course-report':
            return courseReportHeaders()
        case 'enrolled-users':
            return enrolledUsersHeaders()
        case 'user-report':
            return userReportHeaders()
        case 'enrolled-courses':
            return enrolledCoursesHeaders()
        case 'lessons':
            return courseLessonDetailHeaders()
        case 'topics':
            return courseTopicDetailHeaders()
        case 'assignments':
            return courseAssignmentDetailHeaders()
        case 'quiz-details': 
            return userQuizDetails()
        case 'team-members':
          return userTeamMembers()
        case 'team-licenses':
          return userTeamLicenses()
        case 'team-members-seat':
          return userTeamMemberSeat()
        default:
            return []
    }
}
